// extracted by mini-css-extract-plugin
export default {"illustration":"IncodeCaptureSelfie-module__illustration-AWyI","rotate":"IncodeCaptureSelfie-module__rotate-riir"};